<ix-modal-header id="workflowModalHeader"
  >{{ 'overview.workflow.modal_title' | translate }}
</ix-modal-header>
<ix-modal-content>
  @if (loading) {
    <ix-spinner
    class="d-flex justify-content-center"></ix-spinner>
  }
  @if (!loading) {
    <div class="select-product-container">
      <div
        class="d-flex flex-row justify-content-between align-items-center my-3">
        <div class="d-flex flex-row gap-1">
          <ix-typography format="display-xs" id="workflowModalProduct">
            {{ 'overview.workflow.modal_select_product' | translate }}
          </ix-typography>
        </div>
        @if (schemas.length > 3 && schemasToShow !== schemas.length) {
          <ix-button
            (click)="schemasToShow = schemas.length"
            onkeypress=""
            variant="tertiary">
            {{ 'battery_pass.create.more_products' | translate: {length: schemas.length} }}
          </ix-button>
        }
      </div>
      <div [class]="schemasToShow > 3 ? 'flex-wrap' : ''"
        class="d-flex workflow-selector gap-3">
        @for (schemaItem of schemas | slice:0:schemasToShow; track schemaItem) {
          <ix-card
            (click)="setProduct(schemaItem)"
            [selected]="productIsSet && !!schema && schemaItem.id === schema.id"
            class="small-card"
            id="product-card.{{ schemaItem.id }}"
            onkeypress="">
            <div
            [style.background-image]="schemaItem.passportImage ? 
              `url('/assets/img/${schemaItem.passportImage}')` : 
              `url('/assets/img/battery_type_master.jpeg')`"
              class="w-100 overflow-hidden small-card-background">
            </div>
            <ix-card-content>
              <ix-typography [bold]="true" format="display-xs">
                {{ schemaItem.name }}
              </ix-typography>
              @if (schemaItem.type === 'battery' && schemaItem.standardVersion) {
                <ix-pill [outline]="true" variant="info">
                  {{ 'battery_pass.list.longlist_version' | translate }}: v{{ schemaItem.standardVersion }}
                </ix-pill>
              }
              <ix-pill [outline]="true" variant="neutral">
                @if (schemaItem.type === 'battery' && schemaItem.standardVersion) {
                  {{
                    'battery_pass.create.schema_version'
                      | translate: {version: 'v' + schemaItem.version}
                  }}
                } @else {
                  {{
                    'battery_pass.create.schema_version'
                      | translate: {version: schemaItem | schemaVersionLabel: schemas}
                  }}
                }
              </ix-pill>
            </ix-card-content>
          </ix-card>
        }
      </div>
    </div>
    @if (productIsSet && schema && schema.type === 'battery') {
      <div class="select-workflow-container">
        <div
          class="d-flex flex-row align-items-center justify-content-start my-3 gap-1">
          <ix-typography format="display-xs" id="workflowModalDescription">
            {{ 'overview.workflow.modal_select_workflow' | translate }}
          </ix-typography>
        </div>
        <div class="d-flex workflow-selector gap-3">
          <ix-card
            (click)="setWorkflow('eu')"
            [selected]="workflowIsSet && workflow === 'eu'"
            class="small-card"
            id="workflowCardEu"
            onkeypress="">
            <div
              class="w-100 overflow-hidden small-card-background workflow-eu-image"
            ></div>
            <ix-card-content>
              <ix-typography [bold]="true" format="display-xs">
                {{ 'overview.workflow.eu' | translate }}
              </ix-typography>
            </ix-card-content>
          </ix-card>
          <ix-card class="small-card disabled" id="workflowCardUs">
            <div
            class="w-100 overflow-hidden small-card-background workflow-us-image"></div>
            <ix-card-content>
              <ix-typography [bold]="true" format="display-xs">
                {{ 'overview.workflow.us' | translate }}
              </ix-typography>
            </ix-card-content>
          </ix-card>
          <ix-card class="small-card disabled" id="workflowCardOther">
            <div
            class="w-100 overflow-hidden small-card-background workflow-capitol-image"></div>
            <ix-card-content>
              <ix-typography [bold]="true" format="display-xs">
                {{ 'overview.workflow.upcoming_regulations' | translate }}
              </ix-typography>
            </ix-card-content>
          </ix-card>
        </div>
      </div>
    }
    @if ((schema && schema.type === 'battery' && workflowIsSet) ||
      (schema && schema.type !== 'battery' && productIsSet)) {
      <div
        class="select-type-container">
        <div
          class="d-flex flex-row align-items-center my-3 gap-1 justify-content-start">
          <ix-typography format="display-xs" id="workflowModalType">
            {{ 'overview.workflow.modal_select_type' | translate }}
          </ix-typography>
          <ix-icon
            aria-describedby="type-tooltip"
            id="type-info-icon"
            name="info"
            size="16"
          ></ix-icon>
          <ix-tooltip for="#type-info-icon" id="typeTooltip">
            {{ 'overview.workflow.modal_select_type_info' | translate }}
          </ix-tooltip>
        </div>
        <div class="d-flex workflow-selector gap-3">
          <ix-card
            (click)="setMasterChildFlag(MasterChildFlag.MASTER)"
            [selected]="masterChildFlagIsSet && masterChildFlag === MasterChildFlag.MASTER"
            class="small-card w-50"
            id="typeCardMaster"
            onkeypress="">
            <div
              class="w-100 overflow-hidden small-card-background method-master-image"
            ></div>
            <ix-card-content>
              <ix-typography [bold]="true" format="display-xs">
                {{ 'overview.workflow.modal_type_master' | translate }}
              </ix-typography>
            </ix-card-content>
          </ix-card>
          <ix-card
            (click)="setMasterChildFlag(MasterChildFlag.CHILD)"
            [selected]="masterChildFlagIsSet && masterChildFlag === MasterChildFlag.CHILD"
            aria-describedby="child-tooltip"
            class="small-card w-50"
            id="typeCardChild"
            onkeypress="">
            <div
              class="w-100 overflow-hidden small-card-background method-child-image"
            ></div>
            <ix-card-content>
              <ix-typography [bold]="true" format="display-xs">
                {{ 'overview.workflow.modal_type_child' | translate }}
              </ix-typography>
            </ix-card-content>
          </ix-card>
        </div>
      </div>
    }
    @if (masterChildFlagIsSet) {
      <div class="select-method-container">
        <div
          class="d-flex flex-row align-items-center my-3 gap-1 justify-content-start">
          <ix-typography format="display-xs" id="workflowModalMethod">
            {{ 'battery_pass.create.method_label' | translate }}
          </ix-typography>
        </div>
        <div class="d-flex workflow-selector gap-3">
          <ix-card
            (click)="setMethod('ui')"
            [selected]="methodIsSet && method === 'ui'"
            class="small-card w-50"
            id="methodFormCard"
            onkeypress="">
            <div
              class="w-100 overflow-hidden small-card-background method-ui-image">
            </div>
            <ix-typography class="position-relative p-3" format="display-xs">
              {{ 'battery_pass.create.manual_form_entry' | translate }}
            </ix-typography>
          </ix-card>
          <ix-card
            [selected]="methodIsSet && method === 'upload'"
            class="small-card w-50"
            [class.disabled]="!excelConfig"
            [attr.aria-disabled]="!excelConfig"
            [attr.tabindex]="excelConfig ? 0 : -1"
            id="methodExcelCard"
            role="button"
            (click)="excelConfig && setMethod('upload')"
            (keydown.enter)="excelConfig && setMethod('upload')"
            (keydown.space)="$event.preventDefault(); excelConfig && setMethod('upload')">
            <div
              class="w-100 overflow-hidden small-card-background method-upload-image">
            </div>
            <ix-typography class="position-relative p-3" format="display-xs">
              {{ 'battery_pass.create.upload_excel' | translate }}
            </ix-typography>
          </ix-card>
        </div>
      </div>
    }
    @if (methodIsSet && method === 'ui' && schema && schema.type === 'battery') {
      <div
        class="select-battery-category-container">
        <div
          class="d-flex flex-row align-items-center my-3 gap-1 justify-content-start">
          <ix-typography format="display-xs" id="workflowModalBatteryCategory">
            {{ 'battery_pass.create.category_label' | translate }}
          </ix-typography>
        </div>
        <div class="d-flex workflow-selector gap-3">
          <ix-card
            (click)="setCategory(BatteryPassCategoryEnum.ev)"
            (keydown.enter)="setCategory(BatteryPassCategoryEnum.ev)"
            (keydown.space)="$event.preventDefault(); setCategory(BatteryPassCategoryEnum.ev)"
            [selected]="categoryIsSet && category === BatteryPassCategoryEnum.ev"
            [attr.aria-pressed]="categoryIsSet && category === BatteryPassCategoryEnum.ev"
            class="small-card"
            id="categoryEvCard"
            role="button"
            tabindex="0">
            <div
              class="w-100 overflow-hidden small-card-background category-ev-image"
            ></div>
            <ix-typography class="position-relative p-3" format="display-xs">
              {{ 'overview.workflow.category_EV_label' | translate }}
            </ix-typography>
          </ix-card>
          <ix-card
            (click)="setCategory(BatteryPassCategoryEnum.stationary)"
            (keydown.enter)="setCategory(BatteryPassCategoryEnum.stationary)"
            (keydown.space)="$event.preventDefault(); setCategory(BatteryPassCategoryEnum.stationary)"
            [selected]="categoryIsSet && category === BatteryPassCategoryEnum.stationary"
            [attr.aria-pressed]="categoryIsSet && category === BatteryPassCategoryEnum.stationary"
            class="small-card"
            id="categoryStatCard"
            role="button"
            tabindex="0">
            <div
              class="w-100 overflow-hidden small-card-background category-stationary-image">
            </div>
            <ix-typography class="position-relative p-3" format="display-xs">
              {{ 'overview.workflow.category_STAT_label' | translate }}
            </ix-typography>
          </ix-card>
          <ix-card
            (click)="setCategory(BatteryPassCategoryEnum.lmt)"
            (keydown.enter)="setCategory(BatteryPassCategoryEnum.lmt)"
            (keydown.space)="$event.preventDefault(); setCategory(BatteryPassCategoryEnum.lmt)"
            [selected]="categoryIsSet && category === BatteryPassCategoryEnum.lmt"
            [attr.aria-pressed]="categoryIsSet && category === BatteryPassCategoryEnum.lmt"
            class="small-card"
            id="categoryLmtCard"
            role="button"
            tabindex="0">
            <div
              class="w-100 overflow-hidden small-card-background category-lmt-image">
            </div>
            <ix-typography class="position-relative p-3" format="display-xs">
              {{ 'overview.workflow.category_LMT_label' | translate }}
            </ix-typography>
          </ix-card>
          <ix-card
            (click)="setCategory(BatteryPassCategoryEnum.industrial)"
            (keydown.enter)="setCategory(BatteryPassCategoryEnum.industrial)"
            (keydown.space)="$event.preventDefault(); setCategory(BatteryPassCategoryEnum.industrial)"
            [selected]="categoryIsSet && category === BatteryPassCategoryEnum.industrial"
            [attr.aria-pressed]="categoryIsSet && category === BatteryPassCategoryEnum.industrial"
            class="small-card"
            id="categoryInduCard"
            role="button"
            tabindex="0">
            <div
              class="w-100 overflow-hidden small-card-background category-industrial-image">
            </div>
            <ix-typography class="position-relative p-3" format="display-xs">
              {{ 'overview.workflow.category_INDU_label' | translate }}
            </ix-typography>
          </ix-card>
          @if (isSchemaV2OrLater) {
            <ix-card
              (click)="setCategory(BatteryPassCategoryEnum.industrialWithoutBms)"
              (keydown.enter)="setCategory(BatteryPassCategoryEnum.industrialWithoutBms)"
              (keydown.space)="$event.preventDefault(); setCategory(BatteryPassCategoryEnum.industrialWithoutBms)"
              [selected]="categoryIsSet && category === BatteryPassCategoryEnum.industrialWithoutBms"
              [attr.aria-pressed]="categoryIsSet && category === BatteryPassCategoryEnum.industrialWithoutBms"
              class="small-card"
              id="categoryInduNoBmsCard"
              role="button"
              tabindex="0">
              <div
                class="w-100 overflow-hidden small-card-background category-industrial-no-bms-image">
              </div>
              <ix-typography class="position-relative p-3" format="display-xs">
                {{ 'overview.workflow.category_INDU_NO_BMS_label' | translate }}
              </ix-typography>
            </ix-card>
          }
        </div>
      </div>
    }
  }

  @if (methodIsSet && method === 'upload') {
    <div>
      <ix-typography
        class="my-3"
        format="display-xs"
        id="workflowModalUploadFile"
        >
        {{ 'overview.workflow.upload_file' | translate }}
      </ix-typography>
      <ix-upload
        (filesChanged)="onFilesChanged($event)"
        [state]="uploadState"
        accept=".xlsx"
      i18nUploadFile="{{
        'overview.workflow.upload_file_button_text' | translate
      }}"
        id="workflowModalUploadFileInput"
        loadingText="{{ 'overview.workflow.upload_loading_text' | translate }}"
      selectFileText="{{
        'overview.workflow.upload_drag_box_text' | translate
      }}"
      uploadFailedText="{{
        'overview.workflow.upload_failed'
          | translate: {error_message: uploadErrorMessage}
      }}"
        uploadSuccessText="{{ 'overview.workflow.upload_success' | translate }}"
      ></ix-upload>
      @if (uploadErrorDetailMessages && uploadErrorDetailMessages.length > 0) {
        <ix-event-list class="mt-2">
          @for (message of uploadErrorDetailMessages; track message; let i = $index) {
            @if (i < 4) {
              <ix-event-list-item
                class="no-pointer-event"
                itemColor="--theme-color-alarm"
                >{{ message }}
              </ix-event-list-item>
            }
            @if (showAll && i >= 4) {
              <ix-event-list-item
                class="no-pointer-event"
                itemColor="--theme-color-alarm"
                >{{ message }}
              </ix-event-list-item>
            }
          }
        </ix-event-list>
        @if (!showAll && uploadErrorDetailMessages.length > 4) {
          <ix-button
            (click)="showAll = !showAll"
            class="ms-2"
            icon="chevron-down-small"
            onkeypress=""
            variant="subtle-primary"
            >
            {{ 'overview.workflow.upload_show_more_errors_text' | translate }}
          </ix-button>
        }
      }
      <ix-typography
        class="mt-3"
        format="body-sm"
        id="workflowModalUploadFileDescription"
        textColor="soft"
        >
        {{ 'overview.workflow.upload_file_description' | translate }}
        @if (templateAssetPath) {
          <a
            [href]="templateAssetPath"
            download
            id="workflowModalDownloadTemplateLink"
          >{{ 'overview.workflow.upload_file_download_link_text' | translate }}</a>
        }
      </ix-typography>
    </div>
  }
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    class="dismiss-modal"
    id="workflowModalCancel"
    (click)="activeModal.dismiss('dismiss')"
    onkeypress=""
    variant="secondary"
    >
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    (click)="createPassportClick()"
    [disabled]="!createFormComplete"
    class="dismiss-modal"
    id="workflowModalCreateButton"
    onkeypress=""
    variant="primary"
    >
    {{ 'battery_pass.create.create_button_text' | translate }}
  </ix-button>
</ix-modal-footer>
